export const FILE_UPLOAD_IMAGE_PATHS = {
   NORMAL_STATE_PATH: '/assets/images/regular-upload.png',
   ERROR_STATE_PATH: '/assets/images/error-upload.png',
   BROWSE_STATE_PATH: '/assets/images/browsing-file.png',
   UPLOADING_STATE_PATH: '/assets/images/uploading-file.png'
};
